var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGolfBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.8891,
    y1: 73.5225,
    x2: 291.8591,
    y2: 73.5225,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M256.001,392.338H215.16v21.004l0,0c14.178,0,25.671,11.494,25.671,25.671v54.15h30.339 v-54.15c0-14.178,11.493-25.671,25.671-25.671l0,0v-21.004H256.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8096,
    y1: 68.473,
    x2: 254.8096,
    y2: 127.643,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M215.16,392.338v21.004l0,0c14.178,0,25.671,11.494,25.671,25.671v31.389h30.339v-31.389 c0-14.178,11.493-25.671,25.671-25.671v-21.004h-40.842H215.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.2791,
    y1: 152.512,
    x2: 335.4091,
    y2: 152.512,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M291.934,414.465h-71.867c-29.232,0-52.93-23.698-52.93-52.93v-49.099h177.726v49.099 C344.864,390.768,321.166,414.465,291.934,414.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8091,
    y1: 73.883,
    x2: 254.8091,
    y2: 309.003,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M344.864,361.536v-49.099H167.137v46.303l55.725,55.725h69.072 C321.166,414.465,344.864,390.768,344.864,361.536z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 162.2891,
    cy: 493.727,
    r: 363.6,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    cx: 256.001,
    cy: 190.404,
    r: 190.404
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 29.1319,
    cy: 571.487,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    cx: 364.374,
    cy: 258.811,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 101.6019,
    cy: 571.487,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    cx: 291.63,
    cy: 258.811,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 174.0619,
    cy: 571.487,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    cx: 218.875,
    cy: 258.811,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 246.5319,
    cy: 571.487,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    cx: 146.131,
    cy: 258.811,
    r: 28.604
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 65.3619,
    cy: 501.767,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    cx: 328.002,
    cy: 188.818,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 137.8319,
    cy: 501.767,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    cx: 255.248,
    cy: 188.818,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 210.2919,
    cy: 501.767,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    cx: 182.503,
    cy: 188.818,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 282.7619,
    cy: 501.767,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    cx: 109.749,
    cy: 188.818,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: -8.5881,
    cy: 501.767,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    cx: 402.252,
    cy: 188.818,
    r: 28.604
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 29.1319,
    cy: 432.047,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    cx: 364.374,
    cy: 118.824,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 101.6019,
    cy: 432.047,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    cx: 291.63,
    cy: 118.824,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 174.0619,
    cy: 432.047,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    cx: 218.875,
    cy: 118.824,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 246.5319,
    cy: 432.047,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -252.9852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    cx: 146.131,
    cy: 118.824,
    r: 28.604
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 65.3619,
    cy: 527.037,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -140.4858)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    cx: 328.002,
    cy: 326.686,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 137.8319,
    cy: 527.037,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -140.4858)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    cx: 255.248,
    cy: 326.686,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 210.2919,
    cy: 527.037,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -140.4858)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_21_)"
    },
    cx: 182.503,
    cy: 326.686,
    r: 28.604
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 65.3619,
    cy: 255.527,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -140.4858)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_22_)"
    },
    cx: 328.002,
    cy: 54.115,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 137.8319,
    cy: 255.527,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -140.4858)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_23_)"
    },
    cx: 255.248,
    cy: 54.115,
    r: 28.604
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 210.2919,
    cy: 255.527,
    r: 89.14,
    gradientTransform: "matrix(-1.0039 0 0 1.0039 413.8088 -140.4858)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#E0ECF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#D9E8F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#CEE1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#BDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    style: {
      stopColor: "#A7CCE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_24_)"
    },
    cx: 182.503,
    cy: 54.115,
    r: 28.604
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 156.8691,
    cy: 495.533,
    r: 363.6,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    style: {
      stopColor: "#DEEBF1",
      stopOpacity: 0.236
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#D1E3EE",
      stopOpacity: 0.487
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#BCD7E9",
      stopOpacity: 0.745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_25_)"
    },
    cx: 256.001,
    cy: 190.404,
    r: 190.404
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8091,
    y1: 30.693,
    x2: 254.8091,
    y2: -3.557,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_26_)"
    },
    d: "M121.796,471.82h268.408c11.095,0,20.09,8.995,20.09,20.09l0,0 c0,11.095-8.995,20.091-20.09,20.091H121.796c-11.095,0-20.09-8.995-20.09-20.091l0,0C101.706,480.814,110.7,471.82,121.796,471.82z "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGolfBall);
export default __webpack_public_path__ + "static/media/icon-golf-ball.5e4cfeee4170214c37ef8b6d362d17dd.svg";
export { ForwardRef as ReactComponent };